export default "__VITE_ASSET__8d99c69e__"